import "@TestRideEvent/Styles/Main.less"

import BasePage from "@TestRideEvent/Scripts/Pages/BasePage";
import BookingEventSelectionPage from "@TestRideEvent/Scripts/Pages/BookingEventSelectionPage";
import BookingModifyPage from "@TestRideEvent/Scripts/Pages/BookingModifyPage";
import BookingRegistrationPage from "@TestRideEvent/Scripts/Pages/BookingRegistrationPage";
import EventSelectionPage from "@TestRideEvent/Scripts/Pages/EventSelectionPage";
import LiabilityDischargePage from "@TestRideEvent/Scripts/Pages/LiabilityDischargePage";
import ManagePage from "@TestRideEvent/Scripts/Pages/ManagePage";
import TestRideListPage from "@TestRideEvent/Scripts/Pages/TestRideListPage";
import TestRideModifyPage from "@TestRideEvent/Scripts/Pages/TestRideModifyPage";
import TestRideRegistrationPage from "@TestRideEvent/Scripts/Pages/TestRideRegistrationPage";

let App: any = {
    bag: {},
    instances: {},
    pages: {},
    routes: {},
    viewModels: {}
};

App.pages.BasePage = BasePage;
App.pages.BookingEventSelectionPage = BookingEventSelectionPage;
App.pages.BookingModifyPage = BookingModifyPage;
App.pages.BookingRegistrationPage = BookingRegistrationPage;
App.pages.EventSelectionPage = EventSelectionPage;
App.pages.LiabilityDischargePage = LiabilityDischargePage;
App.pages.ManagePage = ManagePage;
App.pages.TestRideListPage = TestRideListPage;
App.pages.TestRideModifyPage = TestRideModifyPage;
App.pages.TestRideRegistrationPage = TestRideRegistrationPage;

(<any>window).App = App;